import { httpService } from "./HttpService";

export interface RegistrationForm {
  email: string;
  fullName: string;
  password: string;
  confirmPassword: string;
  acceptedTnc?: boolean;
  acceptedPrivacyPolicy?: boolean;
}

export const authApi = {
  async register(data: {
    inviteToken: string;
    email: string;
    fullName: string;
    password: string;
    acceptedTnc: boolean;
    acceptedPrivacyPolicy: boolean;
  }) {
    const response = await httpService.post("/users/register", data);
    return response.data;
  },

  async login(credentials: { email: string; password: string }) {
    const response = await httpService.post("/auth/login", credentials);
    return response.data;
  },

  /**
   * Upload a logo image file for a tenant.
   * Requires a valid JWT access token to be set in httpService (via setToken).
   *
   * @param tenantId - The UUID of the tenant
   * @param file     - The image File object (max 5 MB, image/* MIME type)
   */
  async uploadTenantLogo(tenantId: string, file: File): Promise<void> {
    const formData = new FormData();
    formData.append("logo", file);
    await httpService.post(`/tenants/${tenantId}/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
